"use client";

import { useEffect, useState } from "react";
import { getcitydata } from "../../../modules/Graphql/cityquestionandanswergraphql";

export default function CityRankingLink({ cityData }) {
  const [cityRank, setCityRank] = useState(null);
  const [countyName, setCountyName] = useState(cityData?.county_name || "");

  const getcityrank = (county_name, postalcity_name) => {
    var getdata = {
      start: 0,
      limit: 100,
      order: "DESC",
      orderBy: "npiscore_city",
      fields: [
        { name: "county_name", value: county_name, operator: "=" },
        { name: "postalcity_name", value: "", operator: "!=" },
      ],
    };
    getcitydata(getdata)
      .then((result) => {
        let finaldata = result.data.getcitydata;
        let indexdata =
          finaldata &&
          finaldata.length > 0 &&
          finaldata.findIndex(
            (itemData) => itemData.postalcity_name === postalcity_name,
          );
        setCityRank(indexdata + 1);
      })
      .catch((error) => {
        console.error("graphql error: ", error);
      });
  };

  useEffect(() => {
    if (cityData?.id) {
      localStorage.setItem("city_fullName", cityData?.cityfullname || "");
      localStorage.setItem("cityname", cityData?.postalcity_name || "");
      localStorage.setItem(
        "statename",
        cityData?.label?.split(",")?.pop()?.trim() || "",
      );

      const cityCountyName = cityData?.county_name || "";
      setCountyName(cityCountyName);
      const postalcityName = cityData?.postalcity_name || "";
      getcityrank(cityCountyName, postalcityName);
    }
  }, [cityData]);

  const cityRankingUrl = `/Cityranking/best-overall/${countyName?.replace(/\s+/g, "-")}`;

  return (
    <a href={cityRankingUrl} target="_blank">
      Ranked #{cityRank} in {countyName} County
    </a>
  );
}
